export default ['colorful', 'white'] as const;
